export default{
    methods:{
        data(){
            return {
                imageErrorUrls:[]
            }
        },
        imageUrl(url){
            return (this.imageErrorUrls.includes(url) || url.length ==0) ? "/images/vehicle-listing/awaiting-img.jpg" : url.replace('gmvrldev','gmvrl');
        },
        imageLoadFailed(url){
            this.imageErrorUrls.push(url);
        },
    }
}


// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/mixins/imageUrlFallback.js